import * as Yup from 'yup';

export const fallbackValidationSchema = Yup.object().shape({
  days: Yup.string().test(
    'daysRange',
    'deliveryMethods.fallback.errors.daysLimit',
    (value) => {
      if (value && (Number(value) < 0 || Number(value) > 365)) {
        return false;
      }
      return true;
    },
  ),
});
